import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    // English translations
                    //Login Screen
                    phoneNumber: 'Phone Number',
                    password: 'Password',
                    login: 'Login',
                    forgetPassword: 'Forget Password',
                    createAccount: 'Create Account',
                    //Create Account
                    createAccount: 'Create Account',
                    firstName: 'First Name',
                    lastName: 'Last Name',
                    email: 'Email',
                    phoneNumber: 'Phone Number',
                    password: 'Password',
                    address: 'Address',
                    city: 'City',
                    country: 'Country',
                    identityType: 'Identity Type',
                    uploadIdentityImages: 'Upload Identity Images',
                    imagesSelected: 'images selected',
                    submit: 'Submit',
                    //forget password
                    forgetPassword: 'Forget Password',
                    forgetPasswordtext: 'Please enter your phone number to reset your password.',
                    phoneNumber: 'Phone Number',
                    success: 'Password reset successful',
                    //sideBar
                    dashboard: 'Dashboard',
                    units: 'Units',
                    payment: 'Payment',
                    maintenance: 'Maintenance',
                    profile: 'Profile',
                    contracts: 'Contracts',
                    logout: 'Logout',
                    //error Popup
                    error: 'Error',
                    ok: 'OK',
                    //Dashboard
                    Jan: 'Jan',
                    Feb: 'Feb',
                    TotalEarning: 'Total Earning',
                    Availableunits: 'Available Units',
                    TotalRevenue: 'Total Revenue',
                    EGP: 'EGP',
                    TotalBooking: 'Total Booking',
                    //Units
                    all: 'All',
                    live: 'Live',
                    activeNow: 'Active Now',
                    units: 'Units',
                    UnitName: 'Unit Name',
                    UnitStatus: 'Unit Status',
                    Created: 'Created',
                    reserve: 'Reserve',
                    Edit: 'Edit',
                    Delete: 'Delete',
                    //default
                    welcome: 'Welcome',
                    units: 'Units',
                    addUnit: 'Add Unit',
                    map: 'Map',
                    // Add more translations as needed
                }
            },
            ar: {
                translation: {
                    // Arabic translations
                    //Login Screen
                    phoneNumber: 'رقم الهاتف',
                    password: 'كلمة المرور',
                    login: 'تسجيل الدخول',
                    forgetPassword: 'نسيت كلمة المرور',
                    createAccount: 'إنشاء حساب',
                    //Create Account
                    createAccount: 'إنشاء حساب',
                    firstName: 'الاسم الاول',
                    lastName: 'الاسم الاخير',
                    email: 'البريد الإلكتروني',
                    phoneNumber: 'رقم الهاتف',
                    password: 'كلمة المرور',
                    address: 'العنوان',
                    city: 'المدينة',
                    country: 'الدولة',
                    identityType: 'نوع الهوية',
                    uploadIdentityImages: 'رفع صور الهوية',
                    submit: 'إرسال',
                    imagesSelected: 'صور مرفوعة',
                    //forget password
                    forgetPassword: 'نسيت كلمة المرور',
                    forgetPasswordtext: 'يرجى إدخال رقم الهاتف لإعادة تعيين كلمة المرور.',
                    phoneNumber: 'رقم الهاتف',
                    success: 'تم إعادة تعيين كلمة المرور بنجاح',
                    //sideBar
                    dashboard: 'لوحة التحكم',
                    units: 'الوحدات',
                    payment: 'الدفع',
                    maintenance: 'الصيانة',
                    profile: 'الحساب',
                    contracts: 'العقود',
                    logout: 'تسجيل الخروج',
                    //error Popup
                    error: 'خطأ',
                    ok: 'موافق',
                    //Dashboard
                    Jan: 'يناير',
                    Feb: 'فبراير',
                    TotalEarning: 'إجمالي الأرباح',
                    Availableunits: 'الوحدات المتاحة',
                    TotalRevenue: 'إجمالي الإيرادات',
                    EGP: 'ج.م',
                    TotalBooking: 'إجمالي الحجوزات',
                    //Units
                    all: 'الكل',
                    live: 'مباشر',
                    activeNow: 'مفعل الان',
                    units: 'الوحدات',
                    UnitName: 'اسم الوحدة',
                    UnitStatus: 'حالة الوحدة',
                    Created: 'تاريخ الإنشاء',
                    reserve: 'حجز',
                    Edit: 'تعديل',
                    Delete: 'حذف',
                    //default
                    welcome: 'مرحباً',
                    units: 'الوحدات',
                    addUnit: 'إضافة وحدة',
                    map: 'خريطة',
                    // Add more translations as needed
                }
            }
        },
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
        direction: {
            // en: 'ltr',
            // ar: 'rtl'
        },
        supportedLngs: ['en', 'ar'],
        load: 'languageOnly'
    });

export default i18n;